import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Woonggi Kim
 * @contact wgkim@detech.co.kr
 * @date 2024-03-14
 * @brief SEI 커뮤니티 관리 개발
 *
 ********************************************************************/
import { useState } from "react";
//utils
//component
import CommunityManagementCategory from "@components/management/community/CommunityManagementCategory";
import CommunityManagementReport from "@components/management/community/CommunityManagementReport";
import CommunityManagementTree from "@components/management/community/CommunityManagementTree";
import { useOutletContext } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { cmmType } from "../../../recoil/menuState";
function CommunityManagementMain() {
    const cmmSelType = useRecoilValue(cmmType);
    const { handleOpenPop } = useOutletContext();
    const [selTree, setSelTree] = useState(cmmSelType.tabId);
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "box-wrap" }, { children: [_jsx(CommunityManagementTree, { selTree: selTree, setSelTree: setSelTree }), selTree == 0 && _jsx(CommunityManagementCategory, { handleOpenPop: handleOpenPop }), selTree == 1 && _jsx(CommunityManagementReport, { handleOpenPop: handleOpenPop })] })) }));
}
export default CommunityManagementMain;
